import { isBlobUrl } from '../service/previewUrl';

export function createPreviewObjectUrl(file: File): string {
    return URL.createObjectURL(file);
}

export function revokePreviewObjectUrl(url: string): void {
    if (isBlobUrl(url)) {
        URL.revokeObjectURL(url);
    }
}

export function revokePreviewObjectUrls(urls: ReadonlyArray<string>): void {
    urls.forEach(revokePreviewObjectUrl);
}
